/** Resize a textarea to fit its content (capped by CSS max-height). */
export function resizeAutoGrowTextArea(el) {
  if (!el || el.tagName !== 'TEXTAREA') return
  el.style.height = 'auto'
  const cs = getComputedStyle(el)
  const minH = parseFloat(cs.minHeight) || 0
  const maxRaw = cs.maxHeight
  let maxH = Infinity
  if (maxRaw && maxRaw !== 'none') {
    const parsed = parseFloat(maxRaw)
    if (Number.isFinite(parsed) && parsed > 0) maxH = parsed
  }
  const natural = el.scrollHeight
  const next = Math.min(Math.max(natural, minH), maxH)
  el.style.height = `${next}px`
  el.style.overflowY = natural > maxH ? 'auto' : 'hidden'
}
